import { useState, useEffect } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setVisible(false);
      } else {
        setVisible(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        visible ? 'translate-y-0' : '-translate-y-full'
      } ${scrolled ? 'bg-background-50 border-b border-background-200/70' : 'bg-transparent'}`}
      style={{ height: '64px' }}
    >
      <div className="h-full max-w-none mx-auto px-8 md:px-12 flex items-center justify-between">
        <div className="flex items-center gap-10">
          <span className="text-sm font-medium text-foreground-600 whitespace-nowrap">Engineering</span>
          <span className="text-sm font-medium text-foreground-600 whitespace-nowrap flex items-center gap-1">
            Solutions
            <i className="ri-arrow-down-s-line text-xs"></i>
          </span>
          <span className="text-sm font-medium text-foreground-600 whitespace-nowrap">Standards</span>
        </div>

        <div className="absolute left-1/2 -translate-x-1/2">
          <div className="w-6 h-6 rounded-full border-2 border-foreground-800 flex items-center justify-center">
            <div className="w-1.5 h-1.5 rounded-full bg-foreground-800"></div>
          </div>
        </div>

        <div className="w-[200px]"></div>
      </div>
    </nav>
  );
}